import app from "../_app";
//import Slider from "./_slider";

const productBlocks = [...document.querySelectorAll('.js-productblock')];

export const productblockHandler = (productBlock) => {

    const trackbar = productBlock.querySelector('.js-productblock-trackbar');
    const tracker = productBlock.querySelector('.js-productblock-tracker');
    const track = productBlock.querySelector('.js-slider-track');
    const prev = productBlock.querySelector('.js-productblock-prev');
    const next = productBlock.querySelector('.js-productblock-next');
    const images = [...productBlock.querySelectorAll('.img')];

    function imageHandler(direction) {
        let nextImageIndex = 0;

        images.map((image, index) => {
            if(image.hasAttribute('data-current')){
                if(direction === 'prev') {
                    nextImageIndex = index - 1;
                }else if(direction === 'next') {
                    nextImageIndex = index + 1;
                }
                image.removeAttribute('data-current');
            }
        });

        if(nextImageIndex === -1) {
            images[images.length - 1].setAttribute('data-current', '');

        }else if(nextImageIndex < images.length) {
            images[nextImageIndex].setAttribute('data-current', '');

        }else {
            images[0].setAttribute('data-current', '');
        }
    }

    if(prev) {
        prev.addEventListener('click', (e) => {
            e.preventDefault();
            imageHandler('prev');
            productBlock.querySelector('a').classList.add('hovering');
        });
    }

    if(next) {
        next.addEventListener('click', (e) => {
            e.preventDefault();
            imageHandler('next');
            productBlock.querySelector('a').classList.add('hovering');
        });
    }

    if (trackbar) {
        tracker.style.width = 100 / trackbar.getAttribute('data-number') + '%';
    }
    if (track) {
        track.addEventListener('scroll', event => {
            const scrollLeft = Math.round(event.target.scrollLeft / event.target.offsetWidth);
            const position = scrollLeft * 100;

            if (scrollLeft < parseInt(trackbar.getAttribute('data-number'))) {
                tracker.style.transform = 'translateX(' + position + '%)';
            }
        });
    }

    if(app.viewport.isEqualOrGreaterThan('lg')) {

        productBlock.addEventListener('mouseleave', () => {
            images.map((image, index) => {
                image.removeAttribute('data-current');
            });
            productBlock.querySelector('a').classList.remove('hovering');
            images[0].setAttribute('data-current', '');
        });

        images[images.length - 1].addEventListener('mouseenter', (e) => {
            if(!productBlock.querySelector('a').classList.contains('hovering')) {

                images.map((image) => {
                    image.removeAttribute('data-current');
                });

                images[1].setAttribute('data-current', '');
            }
        });
    }
}

productBlocks.map(productBlock => {
    productblockHandler(productBlock);
});


document.addEventListener('click', event => {

    const productBlock = event.target.closest('.js-productblock');

    if (productBlock) {
        const colors = [...productBlock.querySelectorAll('.js-productblock-color')];
        const colorText = productBlock.querySelector('.js-productblock-color-text');
        const track = productBlock.querySelector('.js-slider-track');

        if (colorText) {

            const colorTextDefault = colorText.innerText;

            colors.map(color => {
                color.addEventListener('mouseenter', () => {
                    colorText.innerHTML = color.dataset.title;
                });
                color.addEventListener('mouseleave', () => {
                    colorText.innerHTML = colorTextDefault;
                });

                color.addEventListener('click', () => {

                    if (track) {
                        track.scrollLeft = 0;
                    }
                    colors.map(color => {
                        color.classList.remove('active');
                    });

                    const connectedImages = productBlock.querySelectorAll('.img-connected');
                    connectedImages.forEach(connectedImage => {
                        connectedImage.classList.remove('active');
                    });
                    productBlock.querySelector('.img-connected[data-connected="' + color.dataset.connected + '"]').classList.add('active');
                    color.classList.add('active');

                });

            });
        }
    }
});
